"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSearch = void 0;

var React = __importStar(require("react"));

exports.IconSearch = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M15.8609 31.6483C19.0846 31.6483 22.1011 30.6634 24.6481 29.0014L34.7354 39.0657C35.3083 39.6371 36.0883 40 36.9191 40C37.752 40 38.532 39.688 39.1026 39.0657C40.2991 37.872 40.2991 35.9 39.1026 34.6557L29.068 24.5914C30.7317 22.1006 31.7209 19.0908 31.7209 15.8243C31.7209 7.10743 24.5972 0 15.8604 0C7.12369 0 0 7.10743 0 15.8243C0 24.5411 7.12369 31.6486 15.8604 31.6486L15.8609 31.6483ZM37.6486 36.1111C38.0649 36.5266 38.0649 37.1489 37.6486 37.5643C37.232 37.9797 36.5557 37.9797 36.192 37.5643L26.3118 27.7065C26.8318 27.2403 27.299 26.7722 27.7682 26.2533L37.6486 36.1111ZM15.8609 2.0749C23.4542 2.0749 29.6414 8.24791 29.6414 15.8239C29.6414 23.3998 23.4542 29.5729 15.8609 29.5729C8.26771 29.5729 2.08058 23.3998 2.08058 15.8239C2.08058 8.24791 8.26771 2.0749 15.8609 2.0749Z",
    fill: color
  }), React.createElement("path", {
    d: "M16.381 28.0165C16.9538 28.0165 17.421 27.5504 17.421 26.9789C17.421 26.4073 16.9538 25.9412 16.381 25.9412C10.5043 25.9412 5.72068 21.1684 5.72068 15.3052C5.72068 14.7337 5.25348 14.2676 4.68065 14.2676C4.10783 14.2676 3.64062 14.7337 3.64062 15.3052C3.64062 22.3094 9.36077 28.0165 16.381 28.0165Z",
    fill: color
  }));
});